/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageDto } from '../models/PageDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PagesService {

    /**
     * @param name 
     * @returns PageDto Success
     * @throws ApiError
     */
    public static getPages(
name?: string,
): CancelablePromise<PageDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Pages',
            query: {
                'name': name,
            },
        });
    }

}
